const allProductIds = [
  "42325980152000",
  "41342158831808",
  "41342157455552",
  "41342157258944",
  "42976794116288",
  "41342158733504",
  "43205709955264",
  "41342159159488",
  "41342157226176",
  "41342159323328",
  "42849873494208",
  "41342157652160",
  "41342159454400",
  "41342157422784",
  "43438052835520",
  "41342158438592",
  "43738483065024",
  "45232350560448",
  "45343750881472",
  "45343752880320",
  "45540031856832",
  "45540056072384",
  "45625306480832",
  "41342160961728",
  "41342158962880",
  "41342157390016",
  "41342157127872",
  "41342160142528",
  "43631230910656",
  "41342158766272",
  "41342159192256",
  "41342157160640",
  "41342158471360",
  "41342156570816",
  "41342157357248",
  "41342159421632",
  "44554324312256",
  "43144296005824",
  "43144297087168",
  "43144098218176",
  "43144299839680",
  "43144297709760",
  "46356184268992",
  "46356189642944",
  "46356187316416",
  "47207504019648",
  "47435897045184"
];

// const freeProductIds = ["44481372455104", "45593172803776"];
const freeProductIds = ["44481372455104", "45593172803776"];
const productsRequiredForTheKit = 4;
const byokItems = [];
let chosenFreeProduct = null;
const selectedItems = [];
const selected = "s1";

// This is where the product variants go for the GWP. Make sure you add the VARIANT ID of the free GIFT and NOT the Product ID
let variantsToRemove = [
  "45032692351168", 
  "45538532851904", 
  "44350013145280", 
  "45032719450304",
  "44350011867328", 
  "44350012424384", 
  "45176167596224", 
  "45371457896640", 
  "45371449409728", 
  "45443472064704", 
  "45443468755136", 
  "44610952724672",
  "46432534233280",
  "46432542294208",
  "46432543768768",
  "46432534233280",
  "46445096370368",
  "43606677717184",
  "47186435702976",
  "48235580620992",
  "48341485355200",
  
];

// This is where you change the GWP price threshold
let priceToKeepVariants = 6500;

function checkForFreeGiftsInCart(cart) {
    return cart.items.some(item => variantsToRemove.includes(item.variant_id.toString()));
}

function toggleFreeGiftSection(display) {
    let freeGiftsSection = document.querySelector('.slidecarthq .free-gifts');
  
    if (freeGiftsSection) {
        freeGiftsSection.style.display = display ? 'block' : 'none';
    }
}


function toggleAnnouncementsSection(display) {
    let announcementsSection = document.querySelector('.slidecarthq .announcements');
  
    if (announcementsSection) {
        announcementsSection.style.display = display ? 'block' : 'none';
    }
}

window.SLIDECART_UPDATED = function (cart) {
  let { total_price } = cart;
  let freeGiftRemoved = false;

    if(total_price < priceToKeepVariants) {
      variantsToRemove.forEach(variant => {
        let itemToRemove = document.querySelector(`.slidecarthq .item[data-variant-id='${variant}'] button.remove`);
        if (itemToRemove) {
            itemToRemove.click();  // Remove the free gift
            freeGiftRemoved = true;  // Set the flag to true as a free gift is removed
        }
      })

      if (freeGiftRemoved) {
           let popup = document.querySelector('.MainPopUp');
            if (popup) {
                popup.style.display = 'flex';
                // Add any additional logic for the popup content or behavior here
            }
        }
     toggleAnnouncementsSection(true);
    } else {
      toggleAnnouncementsSection(false);
    }

    let hasFreeGift = checkForFreeGiftsInCart(cart);
    toggleFreeGiftSection(!hasFreeGift);

  

  var cartLinkElement = document.getElementById('cart-link2');

  // Check if the cart has any items
  if (cart.items && cart.items.length > 0) {
    // If there are items in the cart, add the 'productsInCart' class to the div
    cartLinkElement.classList.add('productsInCart');
  } else {
    // If there are no items in the cart, remove the class (if you want to handle cart empty state)
    cartLinkElement.classList.remove('productsInCart');
  }

  
  Shopify.getCart(function (newcart) {
    if (
      newcart.item_count !== cart.item_count ||
      newcart.total_price !== cart.total_price ||
      newcart.token !== cart.token ||
      newcart.items.length !== cart.items.length
    ) {
      window.SLIDECART_CLOSE();
      window.SLIDECART_UPDATE(newcart);
      window.SLIDECART_OPEN();
    }
  }, cart);

  const validProducts = cart.items.filter(
    (item) => allProductIds.indexOf(item.id.toString()) > -1
  );
  const validProductsQty = validProducts
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);
  const validFreeProducts = cart.items.filter(
    (item) => freeProductIds.indexOf(item.id.toString()) > -1
  );
  const validFreeProductsQty = validFreeProducts
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);
  let realKitCount = validFreeProductsQty;
  let expectedKitCount = ~~(validProductsQty / 4);
  const updates = {};

  if (realKitCount === 0 || realKitCount === expectedKitCount) return;

  while (realKitCount > expectedKitCount) {
    const id = validFreeProducts[validFreeProducts.length - 1].id;
    const quantity =
      validFreeProducts[validFreeProducts.length - 1].quantity - 1;
    validFreeProducts[validFreeProducts.length - 1].quantity = quantity;
    updates[id] = quantity;
    realKitCount -= 1;
  }

  jQuery
    .post(window.Shopify.routes.root + "cart/update.js", { updates })
    .complete(() => {
      if (realKitCount <= expectedKitCount) {
        window.SLIDECART_UPDATE();
      }
    });
};

function addItemToByok(id, quantity = 1, img = "") {
  const isProductFromCampaign = allProductIds.indexOf(id) > -1;
  const isFreeProduct = freeProductIds.indexOf(id) > -1;
  if (!isProductFromCampaign && !isFreeProduct) {
    return;
  }

  if (isFreeProduct) {
    if (chosenFreeProduct === null) {
      chosenFreeProduct = id;
      jQuery("#freeItem").attr("src", img);
      jQuery("#freeItem").attr("src", img).show();
      jQuery(".block-1").children()[0].style.display = "block";
      jQuery("#freeItem" + id + "AddToKit").hide();
      jQuery("#freeItem" + id + "RemoveFromKit").show();

      if (id === "43109986762944") {
        jQuery("#freeItem43108178624704AddToKit").prop("disabled", true);
        jQuery("#freeItem43108178624704AddToKit").css("opacity", 0.7);
      } else {
        jQuery("#freeItem43109986762944AddToKit").prop("disabled", true);
        jQuery("#freeItem43109986762944AddToKit").css("opacity", 0.7);
      }
    }
    updateHtml();
    jQuery(".step-1").hide();
    if (selectedItems.length >= 4) {
      jQuery(".step-3").show();
      jQuery(".block-1").removeClass("selected");
      jQuery(".block-2").removeClass("selected");
      jQuery(".block-3").removeClass("selected");
      jQuery(".block-4").removeClass("selected");
      jQuery(".block-5").removeClass("selected");
    } else {
      jQuery(".step-2").show();
      jQuery(".block-1").removeClass("selected");
      jQuery(".block-2").removeClass("selected");
      jQuery(".block-3").removeClass("selected");
      jQuery(".block-4").removeClass("selected");
      jQuery(".block-5").removeClass("selected");
      jQuery(".block-" + (selectedItems.length + 2)).addClass("selected");
    }

    const total = byokItems
      .map((item) => item.quantity)
      .reduce(function (a, b) {
        return a + b;
      }, 0);

    jQuery(".step-2").text("Select " + (4 - total) + " more products");
    return;
  }

  let totalQuantity = byokItems
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);

  if (totalQuantity >= 4) {
    return;
  }

  const isAlreadyAdded = byokItems.findIndex((item) => item.id === id) > -1;
  if (!isAlreadyAdded) {
    byokItems.push({ id, quantity: quantity });
    selectedItems.push({ id, img });
    jQuery(".item-" + selectedItems.length).attr("src", img);
    jQuery(".item-" + selectedItems.length).show();
    jQuery(".block-" + (selectedItems.length + 1)).children()[0].style.display =
      "block";

    totalQuantity = byokItems
      .map((item) => item.quantity)
      .reduce(function (a, b) {
        return a + b;
      }, 0);
    jQuery(".step-2").text("Select " + (4 - totalQuantity) + " more products");

    if (totalQuantity === 4 && chosenFreeProduct) {
      jQuery(".step-1").hide();
      jQuery(".step-2").hide();
      jQuery(".step-3").show();
      jQuery(".block-1").removeClass("selected");
      jQuery(".block-2").removeClass("selected");
      jQuery(".block-3").removeClass("selected");
      jQuery(".block-4").removeClass("selected");
      jQuery(".block-5").removeClass("selected");
      return;
    }

    if (!chosenFreeProduct) {
      jQuery(".block-1").addClass("selected");
      jQuery(".block-2").removeClass("selected");
      jQuery(".block-3").removeClass("selected");
      jQuery(".block-4").removeClass("selected");
      jQuery(".block-5").removeClass("selected");
      return;
    }

    jQuery(".block-1").removeClass("selected");
    jQuery(".block-2").removeClass("selected");
    jQuery(".block-3").removeClass("selected");
    jQuery(".block-4").removeClass("selected");
    jQuery(".block-5").removeClass("selected");
    jQuery(".block-" + (selectedItems.length + 2)).addClass("selected");
    return;
  }

  const itemIndex = byokItems.findIndex((item) => item.id == id);
  if (itemIndex < 0) return;

  byokItems[itemIndex].quantity += quantity;
  selectedItems.push({ id, img });
  jQuery(".item-" + selectedItems.length).attr("src", img);
  jQuery(".item-" + selectedItems.length).show();
  jQuery(".block-" + (selectedItems.length + 1)).children()[0].style.display =
    "block";

  totalQuantity = byokItems
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);
  jQuery(".step-2").text("Select " + (4 - totalQuantity) + " more products");

  if (totalQuantity === 4 && chosenFreeProduct) {
    jQuery(".step-1").hide();
    jQuery(".step-2").hide();
    jQuery(".step-3").show();
    jQuery(".block-1").removeClass("selected");
    jQuery(".block-2").removeClass("selected");
    jQuery(".block-3").removeClass("selected");
    jQuery(".block-4").removeClass("selected");
    jQuery(".block-5").removeClass("selected");
  }

  if (!chosenFreeProduct) {
    jQuery(".block-1").addClass("selected");
    jQuery(".block-2").removeClass("selected");
    jQuery(".block-3").removeClass("selected");
    jQuery(".block-4").removeClass("selected");
    jQuery(".block-5").removeClass("selected");
    return;
  }

  jQuery(".block-1").removeClass("selected");
  jQuery(".block-2").removeClass("selected");
  jQuery(".block-3").removeClass("selected");
  jQuery(".block-4").removeClass("selected");
  jQuery(".block-5").removeClass("selected");
  jQuery(".block-" + (selectedItems.length + 2)).addClass("selected");
}

function removeFreeItem() {
  jQuery("#freeItem").hide();
  jQuery("#freeItem43109986762944AddToKit").show();
  jQuery("#freeItem43109986762944RemoveFromKit").hide();
  jQuery("#freeItem43108178624704AddToKit").show();
  jQuery("#freeItem43108178624704RemoveFromKit").hide();
  jQuery("#freeItem43108178624704AddToKit").prop("disabled", false);
  jQuery("#freeItem43109986762944AddToKit").prop("disabled", false);
  jQuery("#freeItem43108178624704AddToKit").css("opacity", 1);
  jQuery("#freeItem43109986762944AddToKit").css("opacity", 1);
  jQuery(".step-1").show();
  jQuery(".step-2").hide();
  jQuery(".step-3").hide();
  jQuery(".step-4").hide();
  jQuery(".block-1").addClass("selected");
  jQuery(".block-2").removeClass("selected");
  jQuery(".block-3").removeClass("selected");
  jQuery(".block-4").removeClass("selected");
  jQuery(".block-5").removeClass("selected");
  jQuery(".block-1").children()[0].style.display = "none";
}

function getProductId(id) {
  return selectedItems[id].id;
}

function removeItemFromByok(id) {
  const itemIndex = byokItems.findIndex((item) => item.id == id);
  if (itemIndex < 0) {
    if (chosenFreeProduct === id) {
      chosenFreeProduct = null;
      removeFreeItem();
    }
    updateHtml();
    return;
  }

  const quantity = byokItems[itemIndex].quantity;
  if (quantity <= 1) {
    byokItems.splice(itemIndex, 1);
    updateHtml();
    const index = selectedItems.findIndex((i) => i.id === id);
    selectedItems.splice(index, 1);
    jQuery(".item-1").hide();
    jQuery(".item-2").hide();
    jQuery(".item-3").hide();
    jQuery(".item-4").hide();

    selectedItems.map((item, i) => {
      jQuery(".item-" + (i + 1)).attr("src", item.img);
      jQuery(".item-" + (i + 1)).show();
    });

    for (let i = 1; i <= 4; i++) {
      jQuery(".block-" + (i + 1)).children()[0].style.display =
        i <= selectedItems.length ? "block" : "none";
    }

    if (chosenFreeProduct) {
      jQuery(".block-1").removeClass("selected");
      jQuery(".block-2").removeClass("selected");
      jQuery(".block-3").removeClass("selected");
      jQuery(".block-4").removeClass("selected");
      jQuery(".block-5").removeClass("selected");
      jQuery(".block-" + (selectedItems.length + 2)).addClass("selected");
    }

    const total = byokItems
      .map((item) => item.quantity)
      .reduce(function (a, b) {
        return a + b;
      }, 0);
    jQuery(".step-2").text("Select " + (4 - total) + " more products");
    jQuery(".step-3").hide();
    jQuery(".step-2").show();

    return;
  }

  byokItems[itemIndex].quantity -= 1;

  const index = selectedItems.findIndex((i) => i.id === id);
  selectedItems.splice(index, 1);
  jQuery(".item-1").hide();
  jQuery(".item-2").hide();
  jQuery(".item-3").hide();
  jQuery(".item-4").hide();
  selectedItems.map((item, i) => {
    jQuery(".item-" + (i + 1)).attr("src", item.img);
    jQuery(".item-" + (i + 1)).show();
  });

  for (let i = 1; i <= 4; i++) {
    jQuery(".block-" + (i + 1)).children()[0].style.display =
      i <= selectedItems.length ? "block" : "none";
  }

  const total = byokItems
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);
  jQuery(".step-2").text("Select " + (4 - total) + " more products");
  jQuery(".step-3").hide();
  jQuery(".step-2").show();

  if (chosenFreeProduct) {
    jQuery(".block-1").removeClass("selected");
    jQuery(".block-2").removeClass("selected");
    jQuery(".block-3").removeClass("selected");
    jQuery(".block-4").removeClass("selected");
    jQuery(".block-5").removeClass("selected");
    jQuery(".block-" + (selectedItems.length + 2)).addClass("selected");
  }
  return;
}

function addItemsToCart() {
  const productsToBeAdded = byokItems;
  productsToBeAdded.push({ id: chosenFreeProduct, quantity: 1 });

  jQuery
    .post(window.Shopify.routes.root + "cart/add.js", {
      items: productsToBeAdded,
    })
    .complete(() => {
      window.SLIDECART_UPDATE(() => openSlideCart());
      jQuery(".step-3").hide();
      jQuery(".step-4").show();
    });
}

function updateHtml() {
  const totalQuantity = byokItems
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);

  if (totalQuantity >= productsRequiredForTheKit) {
    console.log(chosenFreeProduct);
    if (chosenFreeProduct != null) {
      jQuery(".ready").show();
      jQuery(".missing-free-product").hide();
    } else {
      jQuery(".ready").hide();
      jQuery(".missing-free-product").show();
    }
  } else {
    jQuery(".ready").hide();
    jQuery(".missing-free-product").hide();
  }
}

function getCurrentItems() {
  console.log(byokItems);
}

function openSlideCart() {
  window.SLIDECART_OPEN();
}

function openModal(img, text, id) {
  jQuery(".modalImage").attr("src", img);
  jQuery(".modalHeading").text(text);
  const element = jQuery(".productDescription-" + id).clone()[0];
  element.style.display = "block";
  jQuery(".modalDescription").empty();
  jQuery(".modalDescription").append(element);
  jQuery(".modalBtn").empty();
  jQuery(".modalBtn").append(
    `<button onClick="addItemToByok('` +
      id +
      `', 1, '` +
      img +
      `')" class="btn Button Button--primary quickButton addToKit" style="margin-top:0;">Add to Kit</button></div>`
  );
  jQuery(".modalHolder").show();
}

function closeModal() {
  jQuery(".modalHolder").hide();
}

// jQuery('.addToKit').click(function() {
//   if(jQuery('#freeItem').is(':visible')){
//     jQuery('.block-1').addClass('crossVisible');
//   };

//   if(jQuery('img.item-2').is(':visible')){
//     jQuery('.block-2').addClass('crossVisible');
//   };

//   if(jQuery('img.item-3').is(':visible')){
//     jQuery('.block-3').addClass('crossVisible');
//   };

//   if(jQuery('img.item-4').is(':visible')){
//     jQuery('.block-4').addClass('crossVisible');
//   };

//   if(jQuery('img.item-5').is(':visible')){
//     jQuery('.block-5').addClass('crossVisible');
//   };
// });

// window.SLIDECART_REMOVED_FROM_CART = function({ id }) {
//   const isByokProduct = allProductIds.indexOf(id.toString()) > -1;
//   const isByokFreeProduct = freeProductIds.indexOf(id.toString()) > -1;
//   if (!isByokProduct || !isByokFreeProduct) return;

//   removeItemFromByok(id.toString());
// }

// window.SLIDECART_ADD_TO_CART = function({ id, quantity }) {
//   const isByokProduct = allProductIds.indexOf(id.toString()) > -1;
//   const isByokFreeProduct = freeProductIds.indexOf(id.toString()) > -1;
//   if (!isByokProduct || !isByokFreeProduct) return;

//   addItemToByok(id.toString());
// }
